export const filterParams = (filter: any): Object => {
  Object.keys(filter).forEach(element => {
    if (filter[element] === '' || filter[element] === null || filter[element] === undefined) {
      delete filter[element];
    }
  });
  return { ...filter };
}

export const changeUTCTimeToMilliSecond = (date: Date) => {
  return date.getTime() + date.getTimezoneOffset() * 60000;
}

export const changeUTCMillisecondToDate = (date: number) => {
  const utcTime = new Date(date);
  return new Date(utcTime.getTime() + (utcTime.getTimezoneOffset() * -1) * 60000);
}

export const changeEpochToDate = (date: number) => {
  if (Math.floor(date).toString().length === 10) {
    return new Date(date * 1000);
  }

  if (Math.floor(date).toString().length === 13) {
    return new Date(date);
  }
  else {
    return date;
  }
}

export const flatten = (function (isArray, wrapped) {
  return function (table) {
    return reduce("", {}, table);
  };

  function reduce(path, accumulator, table) {
    if (isArray(table)) {
      const length = table.length;

      if (length) {
        let index = 0;

        while (index < length) {
          const property = path + "[" + index + "]";
          const item = table[index++];
          if (wrapped(item) !== item) accumulator[property] = item;
          else reduce(property, accumulator, item);
        }
      } else accumulator[path] = table;
    } else {
      let empty = true;

      if (path) {
        for (const propKey in table) {
          const item = table[propKey];
          const property = path + "." + propKey;
          empty = false;
          if (wrapped(item) !== item) accumulator[property] = item;
          else reduce(property, accumulator, item);
        }
      } else {
        for (const property in table) {
          const item = table[property];
          empty = false;
          if (wrapped(item) !== item) accumulator[property] = item;
          else reduce(property, accumulator, item);
        }
      }

      if (empty) accumulator[path] = table;
    }

    return accumulator;
  }
}(Array.isArray, Object));

export function jsonifyArrayObj<T>(arr: Array<T>) {
  arr.forEach((dataObject: T) => {
    Object.keys(dataObject).forEach((key: string) => {
      if (typeof dataObject[key] === "object") {
        dataObject[key] = JSON.stringify(dataObject[key]);
      }
    })
  });
  return arr;
}